export default {"src":"/_next/static/media/pre_approved.29e61871.svg","height":114,"width":353,"blurWidth":0,"blurHeight":0};